import React, { useState } from 'react'
import Banner from '../components/Banner'
import AOS from "aos"; // Import AOS library
import Breadcrumb from '../components/Breadcrumb';
import DeveloperStartsFrom from '../components/DeveloperStartsFrom';
import AreaSec from '../sections/area/AreaSec';
import * as constants from "../constants";
import { fetchAPI } from '../helper/fetchAPI';
import { useParams } from 'react-router-dom';
import CustomHelmet from '../components/CustomHelmet';
import { t } from 'i18next';
import FullScreenLoader from '../components/FullScreenLoader';
import { deslugify, detectScript, getDecodedPathParam, replacePathParams, slugify } from '../helper/helperFunction';
import { useTranslation } from 'react-i18next';
import { useCountryPrefix } from '../routes/useCountryPrefix';


const Area = () => {
    const countryPrefix = useCountryPrefix();

    let apiUrl = process.env.REACT_APP_API_URL;
    let langUrl = process.env.REACT_APP_API_URL;

    let { cityName } = useParams();
    const { i18n } = useTranslation();

    const [areaData, setAreaData] = useState();
    const [isLoaded, setIsLoaded] = useState(false);

    const isArabic = i18n.language === "ar";
    const language = isArabic ? "ar" : "en";


    const fetchData = async () => {

        const currentUrl = window.location.href;
        let replacement = {};
        let convPathCityName = getDecodedPathParam(currentUrl, "area/:cityName", "cityName")

        if ((language === "en" && (detectScript(convPathCityName) === "arabic")) || (language === "ar" && (detectScript(convPathCityName) === "english"))) {
            langUrl = `${langUrl}${constants.localization}?CityName=${cityName}`
            const resLocalization = await fetchAPI(langUrl, "Get");
            const pattern = `${countryPrefix}${language === "ar" ? "/ar" : ""}/area/:cityName`;
            replacement = {
                cityName: slugify(isArabic ? resLocalization.data.cityName.ar : resLocalization.data.cityName.en),
            }
            var newUrl = replacePathParams(currentUrl, pattern, replacement)

            window.history.replaceState({}, '', newUrl);
            cityName = slugify(isArabic ? resLocalization.data.cityName.ar : resLocalization.data.cityName.en)
        }

        apiUrl = `${apiUrl}${constants.areasdetails}?language=${language}&cityName=${deslugify(cityName)}`;
        const res = await fetchAPI(apiUrl, "Get");

        if (res?.status === 200) {

            setAreaData(res?.data)
            setIsLoaded(true)

        }
    }


    React.useEffect(() => {
        AOS.init();
        fetchData();
    }, []);

    const pathLang = isArabic ? "/ar" : "";

    const pathName = [
        { name: t("home"), path: `/${countryPrefix}${pathLang ? `${pathLang}` : ""}` },
        { name: t("area") }
    ];

    if (!isLoaded) {
        return (
            <FullScreenLoader />
        )
    }
    return (
        <>
            <CustomHelmet
                title={"Exclusive Real Estate Across Egypt"}
                desc={'Connect Homes makes exploring real estate in Egypt simple and seamless.'}
            />
            <Banner
                title={t("area_details")}
                desc={t("banner_desc")}
            ></Banner>
            <Breadcrumb pathName={pathName}>
            </Breadcrumb>
            <AreaSec areaData={areaData} areaName={cityName}></AreaSec>

        </>
    )
}

export default Area